import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { Input } from "./ui/input";

/**
 * Input field with an in-line "copy value" button on the right.
 * Uses the browser Clipboard API; falls back gracefully if it's not available.
 */
export const CopyableInput = ({ value, onChange, className = "", testid, ...rest }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    const v = (value ?? "").toString();
    if (!v) return;
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(v);
      } else {
        const ta = document.createElement("textarea");
        ta.value = v;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopied(true);
      toast.success(`Copied "${v}"`);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Could not copy");
    }
  };

  return (
    <div className="relative">
      <Input
        value={value}
        onChange={onChange}
        className={`${className} pr-9`}
        data-testid={testid}
        {...rest}
      />
      <button
        type="button"
        onClick={copy}
        aria-label="Copy value"
        title={value ? `Copy "${value}"` : "Nothing to copy"}
        data-testid={testid ? `${testid}-copy` : undefined}
        className={`absolute right-1.5 top-1/2 -translate-y-1/2 h-7 w-7 inline-flex items-center justify-center rounded-md ${
          value
            ? "text-[#3f4b52] hover:text-[#f28a16] hover:bg-[#edf2f4]"
            : "text-[#cfd7db] cursor-not-allowed"
        }`}
        disabled={!value}
      >
        {copied ? <Check size={13} className="text-[#10b981]" /> : <Copy size={13} />}
      </button>
    </div>
  );
};

export default CopyableInput;
